"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function LangSetterWrapper() {
  const pathname = usePathname();

  useEffect(() => {
    const locale = pathname.split("/")[1] || "en";
    document.documentElement.lang = locale;
  }, [pathname]);

  return null;
}
